import { Component, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { UiText } from '@ory/client';
import { SharedModule } from 'src/app/core/shared.module';
import { tv } from 'tailwind-variants';

@Component({
  selector: 'v-kratos-message',
  imports: [SharedModule, TranslocoPipe],
  template: `
    <div class="flex flex-col gap-2">
      @for (msg of message(); track msg) {
        <div [class]="classes(msg)">
          {{ 'kratosMessages.' + msg.id | transloco }}
        </div>
      }
    </div>
  `,
})
export class VKratosMessageComponent {
  message = input.required<UiText[]>();

  public classes(msg: UiText) {
    return this.messageVariants({
      type: msg.type as 'error' | 'success' | 'info',
    });
  }

  private messageVariants = tv({
    base: `p-3 rounded-md mb-4`,
    variants: {
      type: {
        error: 'bg-red-600/10 text-red-500',
        success: 'bg-green-600/10 text-green-500',
        info: 'bg-blue-600/10 text-blue-500',
      },
    },
    defaultVariants: {
      type: 'error',
    },
  });
}
